<template>
    <div class="root">
         <div v-for="(item, index) in lang" :key="index" class="forDic">
            <div :class="['finish', { long: showList.length > 3 }]">
                <div class="textDiv" style="margin-bottom: 4rem !important">{{ item[2] }}</div>
                <div class="awardListWrap">
                    <div class="imgWrap" v-for="val in showList.slice(0, 3)" :key="val.order">
                        <img :src="val.prize_img" alt="" />
                    </div>
                </div>
                <div class="awardListWrap" v-show="showList.length > 3">
                    <div class="imgWrap" v-for="val in showList.slice(3, 6)" :key="val.order">
                        <img :src="val.prize_img" alt="" />
                    </div>
                </div>
                <div class="textDiv">{{ item[3] }}</div>
                <!-- 分享模块 -->
                <div class="shareModule" v-show="showList.length < 4 && !showGift">
                    <div class="shareWrap">
                        <div class="sharewrap">
                            <div class="textDiv">{{ item[4] }}</div>
                            <div @click="onShare('facebook')" style="display: inline-block">
                                <img src="@/assets/images/btn_fb.png" alt="" />
                            </div>
                            <div @click="onShare('twitter')" style="display: inline-block">
                                <img src="@/assets/images/btn_twitter.png" alt="" />
                            </div>
                            <div @click="onShare('line')" style="display: inline-block">
                                <img src="@/assets/images/btn_line.png" alt="" />
                            </div>
                            <div class="href">
                                <a style="color: #002dc1; text-decoration: underline;font-weight: 800" :href="storeURL">{{ item[10] }}</a>
                            </div>
                        </div>
                    </div>
                    <!-- 直接领取 -->
                    <div class="btnWrap" @click="handleFinish">{{ item[5] }}</div>
                </div>
                <!-- 礼包码模块 -->
                <div class="awardModule" v-show="showList.length > 3 || showGift">
                    <div class="awardWrap">
                        <h3>{{ copyValue }}</h3>
                        <!-- <input type="text" v-model="copyValue" id="input" class="input" /> -->
                        <div>
                            <h5 class="tag-read" :data-clipboard-text="copyValue" @click="copys">{{ item[6] }}</h5>
                            <p></p>
                            <h5 @click="handleExchange">{{ item[7] }}</h5>
                        </div>
                    </div>
                    <div class="href">
                        <a style="color: #002dc1; text-decoration: underline;font-weight: 800" :href="storeURL">{{ item[10] }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="tooltip" v-show="infoShow">
            <div class="tooltiptext">{{ tooltipMsg }}</div>
        </div>
    </div>
</template>

<script>
import queryString from 'query-string'
import Clipboard from 'clipboard'
import { lang } from '@/tool/archeroLang'
import arrList from '@/data/prize.js'
import { myHTTP } from '../utils/net'

var parsed = queryString.parse(location.search || '') || {}

function isTestOrLocalEnv() {
    // 与 net.js 环境判断对齐，并覆盖本地开发场景
    const host = (window.location.host || '').toLowerCase()
    const hostname = (window.location.hostname || '').toLowerCase()
    const href = (window.location.href || '').toLowerCase()
    const port = window.location.port || ''

    if (parsed.env === 'test' || parsed.local === '1') return true
    if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]' || hostname === '::1') {
        return true
    }
    if (href.indexOf('localhost') >= 0 || href.indexOf('127.0.0.1') >= 0) return true
    if (host.indexOf('test') > -1 || hostname.indexOf('test') > -1) return true
    if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return true
    // webpack-dev-server 常见端口
    if (port === '8080' || port === '8090') return true
    return false
}

export default {
    props: ['bingoList', 'anniversaryCode'],
    data() {
        let shareURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        if (window.location.href.indexOf('https://test-h5-archero') === 0) {
            shareURL = 'https://test-giftcode-archero.habby.com/api/v1/thirdparty/auth'
        } else if (window.location.href.indexOf('https://h5-archero') === 0) {
            shareURL = 'https://giftcode-archero.habby.com/api/v1/thirdparty/auth'
        }

        return {
            tooltipMsg: '',
            infoShow: false,
            shareURL: '',
            copyValue: '',
            isLogged: true,
            lang: [{}],
            language: '',
            lang2: '',
            showList: [],
            showGift: false
        }
    },
    computed: {
        storeURL() {
            return isTestOrLocalEnv()
                ? 'https://test-store.habby.com/game/2'
                : 'https://store.habby.com/game/2'
        }
    },
    watch: {
        infoShow(newValue, oldValue) {
            if (newValue) {
                let timeoutId = setTimeout(
                    function () {
                        this.infoShow = false
                        clearTimeout(timeoutId)
                    }.bind(this),
                    2000
                )
            }
        },
        // prop 后到或异步赋值时，确保切到礼包码模块
        anniversaryCode: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.applyExistingGiftCode(val)
                }
            }
        }
    },
    created() {
        this.getLanguage()
        for (let i in lang) {
            this.lang[0][i] = lang[i][this.language]
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        applyExistingGiftCode(code) {
            if (!code) return
            this.copyValue = code
            this.showGift = true
        },
        init() {
            let arr = []
            const list = Array.isArray(this.bingoList) ? this.bingoList : []
            list.forEach(item => {
                // bingoList 存的是 order（1-based）
                const prize = arrList[item - 1]
                if (prize) arr.push(prize)
            })
            this.showList = arr
            console.log(this.bingoList, arr, 'bingoList')

            // 优先 prop，其次 localStorage（回访已有码）
            const existingCode =
                this.anniversaryCode || localStorage.getItem('anniversaryCode2026') || ''
            if (existingCode) {
                this.applyExistingGiftCode(existingCode)
            }

            // 已有码则不再 create；仅在奖品较多且本地/服务端都还没有码时再拉码
            if (this.showList.length > 5 && !existingCode) {
                this.getGiftCode()
            }
        },
        handleExchange() {
            // 与 store 链接同一套环境判断：test/本地 → test-store，正式 → store
            const base = isTestOrLocalEnv()
                ? 'https://test-store.habby.com/game/2'
                : 'https://store.habby.com/game/2'
            const code = encodeURIComponent(this.copyValue || '')
            window.location = `${base}?giftcode=${code}&page=giftcode`
        },
        onShare(shareType) {
            console.log(shareType)
            let str = 'share_' + shareType
            if (window.thinkingdata && typeof window.thinkingdata.track === 'function') {
                window.thinkingdata.track('anniversary2026_h5_event', {
                    step: str
                })
            }

            let myGameURL = 'https://h5-archero.habby.com/anniversary2026/index.html'

            if (window.location.host.indexOf('test') > -1) {
                myGameURL = 'https://test-h5-archero.habby.com/anniversary2026/index.html'
            }

            if (location.hostname.match(/[0-9]+\.[0-9]+\.[0-9]+\.[0-9]+/)) {
                myGameURL = 'https://test-h5-archero.habby.com/anniversary2026/index.html'
            }

            if (shareType == 'facebook') {
                let facebookShareURL = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(myGameURL)
                // window.location.href = facebookShareURL;
                window.open(facebookShareURL)
            } else if (shareType == 'twitter') {
                let twitterShareURL = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(myGameURL)
                // window.location.href = twitterShareURL;
                window.open(twitterShareURL)
            } else {
                window.open('https://game.naver.com/lounge/Archero/home')
            }

            this.$emit('handleCreated')
        },
        copys() {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                this.tooltipMsg = this.lang[0][8] || '礼包码已复制'
                console.log('礼包码复制成功')
                this.infoShow = true
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                console.log('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        handleFinish() {
            if (window.thinkingdata && typeof window.thinkingdata.track === 'function') {
                window.thinkingdata.track('anniversary2026_h5_event', {
                    step: 'share_0'
                })
            }
            this.getGiftCode()
        },
        getGiftCode() {
            let uuid = parsed.uuid || localStorage.getItem('uuid')
            let r = this.showList.map(item => {
                return parseInt(item.prize_id)
            })
            myHTTP
                .post('/api/v1/anniversary2026/create', {
                    uuid,
                    giftCode: 'anniversary2026H5',
                    r
                })
                .then(res => {
                    if (res.data.code == 0) {
                        this.copyValue = res.data.data.myGiftCode
                        this.showGift = true
                        try {
                            localStorage.setItem('anniversaryCode2026', res.data.data.myGiftCode)
                        } catch (e) {}
                    } else {
                        alert(res.data.message)
                    }
                })
                .catch(err => {
                    console.warn('getGiftCode failed', err)
                    alert('网络异常，请稍后重试')
                })
        },
        getLanguage() {
            if (
                parsed.language &&
                (parsed.language === 'en' ||
                    parsed.language === 'zh-TW' ||
                    parsed.language === 'zh-CN' ||
                    parsed.language === 'ja' ||
                    parsed.language === 'ko')
            ) {
                this.language = parsed.language
                // this.abc = this.language
                this.lang2 = this.language.substr(0, 2)
                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            } else {
                var type = navigator.appName
                if (type == 'Netscape') {
                    var lang = navigator.language //获取浏览器配置语言，支持非IE浏览器
                } else {
                    var lang = navigator.userLanguage //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
                }
                var lang2 = lang.substr(0, 2) //获取浏览器配置语言前两位
                this.lang2 = lang2
                if (lang2 === 'zh') {
                    let zh = lang.substr(0, 5)
                    this.language = zh
                } else if (lang2 == 'ko') {
                    this.language = 'ko'
                } else if (lang2 == 'ja') {
                    this.language = 'ja'
                } else {
                    this.language = 'en'
                }
                if (this.language === 'zh-cn') {
                    this.language = 'zh-CN'
                }
                if (this.language === 'zh-tw') {
                    this.language = 'zh-TW'
                }
                if (['en', 'ja', 'ko', 'zh-CN', 'zh-TW'].indexOf(this.language) < 0) {
                    this.language = 'en'
                }
                // this.abc = this.language

                // this.srcUrl = this.srcList[this.language.substr(0, 2)]
            }
        }
    }
}
</script>


<style scoped lang="less">
.root {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    max-width: 1024px;
    margin: 0 auto !important;
    text-align: center;
    padding: 3.75rem 2.5rem;
    box-sizing: border-box;
    overflow-y: auto;
    // 半透明遮罩用伪元素，不占用内容背景，避免破坏弹板图
    background: transparent;
    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        max-width: 1024px;
        margin: 0 auto;
        background: rgba(0, 0, 0, 0.3);
        z-index: 0;
        pointer-events: none;
    }
    .forDic {
        height: 100%;
        position: relative;
        z-index: 1;
        .finish {
            width: 100%;
            background: url('../assets/images/board_long.png') 100% 100% no-repeat;
            background-size: 100% 100%;
            padding: 36rem 0 7.5rem;
            line-height: 1.4;
            color: #fff;
            font-size: 2.25rem;
            // 奖励展示
            .awardListWrap {
                padding: 0 12.5rem 2.25rem;
                width: 100%;
                display: flex;
                justify-content: space-around;
                .imgWrap {
                    width: 100%;
                    padding: 0.625rem 0.375rem;
                    width: 9.5rem;
                    background: url('../assets/images/itembg.png') 100% 100% no-repeat;
                    background-size: 100% 100%;
                    img {
                        width: 100%;
                    }
                }
            }
            .textDiv {
                padding: 0 5rem;
                margin: 1.25rem 0 !important;
            }
            // 分享模块
            .shareModule {
                .shareWrap {
                    margin-top: 1.875rem !important;
                    padding: 0 5rem;
                    .sharewrap {
                        width: 100%;
                        background: url('../assets/images/share_fbtwitterline_bg.png') 100% 100% no-repeat;
                        background-size: 100% 100%;
                        padding: 4.675rem 0 6.75rem;
                        position: relative;
                        .textDiv {
                            padding: 0 4rem;
                        }
                        div:nth-child(3) {
                            margin: 0 1.75rem !important;
                        }
                        img {
                            margin-top: 1.75rem;
                            width: 9.125rem;
                        }
                        .href{
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                        }
                    }
                }
                // 获取按钮
                .btnWrap {
                    text-align: center;
                    background: url('../assets/images/greenbtn.png') 100% 100% no-repeat;
                    background-size: 100% 100%;
                    display: inline-block;
                    font-size: 2.75rem;
                    height: 12rem;
                    line-height: 12rem;
                    // padding: 2.125rem 4.75rem 3rem;
                    padding: 0 5rem;
                }
            }
            // 礼包码模块
            .awardModule {
                width: 100%;
                .awardWrap {
                    background: url('../assets/images/final_pinnumber_bg.png') 100% 100% no-repeat;
                    background-size: 100% 100%;
                    min-width: 38.8125rem;
                    margin: 1.25rem auto 0 !important;
                    padding: 3.25rem 4rem 4rem;
                    display: inline-block;
                    max-width: 80vw;
                    h3 {
                        color: #131415;
                        font-size: 3.15rem;
                        min-height: 3.15rem;
                    }
                    div {
                        display: inline-block;
                        min-width: 22.5rem;
                        h5 {
                            width: 100%;
                            display: inline-block;
                            background: #077d26;
                            color: #fff;
                            font-size: 1.875rem;
                            padding: 1.8rem 3rem;
                            margin-top: 1.25rem !important;
                            border-radius: 6.25rem;
                        }
                    }
                }
            }
        }
        .long {
            background: url('../assets/images/board_long.png') 100% 100% no-repeat;
            background-size: 100% 100%;
        }
    }
}

.tooltip {
    width: 100%;
    position: fixed;
    left: 0;
    top: 6.25rem;
    z-index: 200; // 高于完成弹窗遮罩/内容层
    text-align: center;
    pointer-events: none;
    .tooltiptext {
        max-width: 60%;
        background: rgba(0, 0, 0, 0.75);
        display: inline-block;
        padding: 3.25rem;
        border-radius: 2.625rem;
        color: #ffffff;
        font-size: 2.2rem;
        pointer-events: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/finish.vue